import { useEffect } from 'react';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export const GA_MEASUREMENT_ID = 'G-CNZML936DK';

export const initializeGA = () => {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID);
};

export const trackPageView = (url: string) => {
  if (typeof window === 'undefined') return;
  
  // Ensure URL is properly encoded to prevent URL construction errors
  const encodedUrl = encodeURIComponent(url);
  
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: encodedUrl,
  });
};

export const trackEvent = (
  action: string,
  category: string,
  label?: string,
  value?: number
) => {
  if (typeof window === 'undefined') return;

  // Make sure to encode any string parameters that might contain special characters
  const safeLabel = label ? encodeURIComponent(label) : undefined;

  window.gtag('event', action, {
    event_category: category,
    event_label: safeLabel,
    value: value,
  });
};

// Safe wrapper around fetch for analytics-related calls
export const safeFetch = async (url: string, options?: RequestInit) => {
  try {
    // Validate URL before fetching
    new URL(url); // This will throw if URL is invalid
    return fetch(url, options);
  } catch (error) {
    // Silently log error without breaking the app
    console.warn('Analytics fetch error:', error);
    return null;
  }
};